// extracted by mini-css-extract-plugin
export var black = "_42-6";
export var brand = "_42-1";
export var ddefault = "_42-0";
export var error = "_42-3";
export var gray = "_42-2";
export var highContrast = "_42-8";
export var outline = "_42-7";
export var success = "_42-5";
export var warning = "_42-4";